// src/hooks/currencies/useGetCurrencies.js
import { useQuery } from "@tanstack/react-query";
import { getAllCurrencies } from "../../api/apiCurrencies";

function useGetCurrencies(page, perPage, filters = {}) {
    const { isLoading, error, data } = useQuery({
        queryKey: ["currencies", page, perPage, filters],
        queryFn: () => getAllCurrencies(page, perPage, filters),
    });

    return {
        isLoading,
        error,
        currencies: data?.data || {},
        meta: data?.data?.meta || {},
    };
}

export default useGetCurrencies;
